// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  .single_article_top_details_wrapper {
    width: 90%;
    display: flex !important;
    gap: 4%;
  }
  .single_article_title_report_share_save_container {
    height: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between !important;
    padding: 2% 0 2% 0;
  }
  .single_article_second_column_container {
    width: 65%;
  }
  .single_article_first_column_title {
    color: #ffffff;
    font-size: 20px;
    padding: 2% 0 0 0;
    height: 70%;
  }
  .single_article_first_column_container {
    width: 35%;
  }
  .single_article_writer_details {
    display: flex;
    align-items: center;
  }
  .report_share_container {
    display: none;
  }
  .whatsapp_gif_icon_container {
    width: 15%;
  }
  .whatsapp_channel_content {
    width: 100%;
    font-size: 15px;
  }
  .single_article_donation_container {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .single_article_content_container {
    width: 60%;
    gap: 30px;
  }


  .single_article_icons {
    font-size: 12px;
  }
  .writer_name {
    font-size: 15px;
  }
  .published_date {
    font-size: 15px;
  }
  .social_media_card_container {
    gap: 15px;
    padding: 7% 0 7% 15%;
  }
  .join_whatsapp_channel_division {
    display: none;
  }
  .donation_card_mobile_view {
    display: none;
  }
  .writer_profile_image {
    width: 80px !important;
    height: 80px !important;
  }
  .single_article_first_column_title_ta {
    color: #ffffff;
    font-size: 17px;
    padding: 2% 0 0 0;
    height: 80%;
  }
  .single_view_article_icons {
    width: 20px;
  }
  .report_container_second_column {
    font-size: 12px;
  }
  .we_are_committed_text {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_1024_1439/screen_1024_1439_single_article.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,OAAO;EACT;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,UAAU;IACV,SAAS;EACX;;;EAGA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n  .single_article_top_details_wrapper {\n    width: 90%;\n    display: flex !important;\n    gap: 4%;\n  }\n  .single_article_title_report_share_save_container {\n    height: 60%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between !important;\n    padding: 2% 0 2% 0;\n  }\n  .single_article_second_column_container {\n    width: 65%;\n  }\n  .single_article_first_column_title {\n    color: #ffffff;\n    font-size: 20px;\n    padding: 2% 0 0 0;\n    height: 70%;\n  }\n  .single_article_first_column_container {\n    width: 35%;\n  }\n  .single_article_writer_details {\n    display: flex;\n    align-items: center;\n  }\n  .report_share_container {\n    display: none;\n  }\n  .whatsapp_gif_icon_container {\n    width: 15%;\n  }\n  .whatsapp_channel_content {\n    width: 100%;\n    font-size: 15px;\n  }\n  .single_article_donation_container {\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .single_article_content_container {\n    width: 60%;\n    gap: 30px;\n  }\n\n\n  .single_article_icons {\n    font-size: 12px;\n  }\n  .writer_name {\n    font-size: 15px;\n  }\n  .published_date {\n    font-size: 15px;\n  }\n  .social_media_card_container {\n    gap: 15px;\n    padding: 7% 0 7% 15%;\n  }\n  .join_whatsapp_channel_division {\n    display: none;\n  }\n  .donation_card_mobile_view {\n    display: none;\n  }\n  .writer_profile_image {\n    width: 80px !important;\n    height: 80px !important;\n  }\n  .single_article_first_column_title_ta {\n    color: #ffffff;\n    font-size: 17px;\n    padding: 2% 0 0 0;\n    height: 80%;\n  }\n  .single_view_article_icons {\n    width: 20px;\n  }\n  .report_container_second_column {\n    font-size: 12px;\n  }\n  .we_are_committed_text {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
